import { Observable } from 'rxjs';
import { InjectionToken } from '../../injection';

import { EmptyResponse } from '../data/empty-response.do';
import { MobizSession } from '../data/mobiz-session.do';
import { Organization } from '../data/organization.do';
import { User } from '../data/user.do';

import { IAuthGrantClientCredentialsGrantTypeSecret, IAuthGrantPasswordGrantTypeSecret } from './auth-token.interface';
import {TextResponse} from "../data/text-response.do";
import {AudkenniCode} from "../data/audkenni-code.do";

export interface IAuthService {
  /** Returns if the user is an administrator or not. */
  isAdmin(): boolean;

  /** Returns true if user is logged in using a password. */
  isLoggedIn(): boolean;

  /** Returns true if user is logged in using client credentials. */
  isLoggedInUsingClientCredentials(): boolean;

  /**
   * LogIn Mobiz.
   * @param credentials User credentials.
   */
  logIn(credentials: IAuthGrantPasswordGrantTypeSecret): Observable<MobizSession>;

  /**
   * Login using client credentials.
   * @param credentials Guest user credentials.
   */
  logInUsingClientCredentials(credentials: IAuthGrantClientCredentialsGrantTypeSecret): Observable<MobizSession>;

  /** LogOut of Mobiz. */
  logOut(): Observable<EmptyResponse>;

  /** Forgot password. */
  forgotPassword(email: string): Observable<EmptyResponse>;

  /**
   * Gets the user.
   *
   * @param userId User identifier.
   */
  getUser(userId: string): Observable<User>;

  /**
   * Gets the organization.
   *
   * @param organizationId Organization identifier.
   *
   * @deprecated Use IOrganizationService.getOrganization()
   */
  getOrganization(organizationId: string): Observable<Organization>;

  /**
   * Refresh the OAuth token.
   */
  refreshToken(): Observable<void>;
  
  /**
   * Get the Audkenni verification code and corresponding hash.
   */
  getAudkenniCode(): Observable<AudkenniCode>;
  
  /**
   * Initialize authentication polling for electronic ID login.
   * Returns a verification ID that can be used for polling.
   * @param idValue The user's identification number or phone number
   * @param hash The hash from Audkenni code
   * @param useAudkenniApp Whether to use app polling (true) or SIM polling (false)
   */
  initializeAuthPoll(idValue: string, hash: string, useAudkenniApp: boolean): Observable<TextResponse>;
  
  /**
   * Poll for authentication status using the verification ID.
   * @param verificationId The verification ID from initializeAuthPoll.
   * @param noTimeout Whether to disable the timeout for the request
   */
  pollAuthStatus(verificationId: string, noTimeout: boolean): Observable<TextResponse>;
  
  
  /**
   * Refresh the OAuth token in the background.
   *
   * @deprecated use IAuthService.refreshToken()
   */
  refreshTokenInBackground(): void;
}
export const IAuthService = new InjectionToken('IAuthService');
